import React from 'react'

const TabsContext = React.createContext()

export default TabsContext
